import type {StakeholderType} from '@deezer/next/services/api/Starmania/requests/album/types';
import type {Album} from '@deezer/next/services/api/Starmania/requests/album/types';

export enum CampaignCountries {
	FR = 'FR',
	BR = 'BR',
	MX = 'MX',
}

export enum CampaignStatuses {
	DENIED = 'Denied',
	PENDING = 'Pending',
	WAITING_IO = 'Waiting for IO',
	APPROVED = 'Approved',
	RUNNING = 'Running',
	DONE = 'Done',
	REPORT_READY = 'Report Ready',
}

export type CampaignBudgetRange = {
	minBudget: number;
	// TODO: uncomment for V1
	// minImpressions: number
};

export enum CampaignSegments {
	SUPERFAN = 'superfan',
	FAN = 'fan',
	ENGAGED_STREAMER = 'engaged_streamer',
	QUALIFIED_STREAMER = 'qualified_streamer',
	CASUAL_STREAMER = 'casual_streamer',
	SIMILAR_ARTISTS_AUDIENCE = 'similar_artists_audience',
}

export type CampaignCreate = {
	upc: string;
	stakeholderType?: StakeholderType.PROVIDER | StakeholderType.LABEL;
	providerId?: number;
	labelId?: number;
	startDate: string;
	country: CampaignCountries;
	segments: CampaignSegments[];
	budget: number;
};

export type ClaimCreate = {
	claimContentType: string;
	claimNature: string;
	claimType: string;
	countries: Array<string>;
	deezerLinks: Array<string>;
	email: string;
	firstname: string;
	lastname: string;
	reason: string;
	rightsholderRelationship: string;
};

export type CampaignEdit = {
	budget: number;
	startDate: string;
	segments: CampaignSegments[];
};

export type Campaign = {
	id: number;
	album: Album;
	author: string;
	budget: number;
	upc: string;
	stakeholderType: StakeholderType.PROVIDER | StakeholderType.LABEL;
	startDate: string;
	creationDate: string;
	country: CampaignCountries;
	segments: CampaignSegments[];
	status: CampaignStatuses;
	rejectReason?: string;
};
